<template>
    <div style="width: 900px; background-color: #fff; margin:0 auto; position: relative; border: 3px solid #efefef; padding: 20px;">
        <img style="max-width: 600px;" src="./i1.png"/>
        <table width="100%" style="border-top: 1px solid #efefef; font-size: 16px;">
            <tbody>
            <tr>
                <!--<td width="250" valign="top" style="border-right: 1px solid #efefef; padding-top: 15px;">-->
                    <!--aside-->
                <!--</td>-->
                <td valign="top" align="left" style="padding: 15px;">
                    <div style="font-size: 16px; color: #2f62ff; font-weight: bold;">Найдено 6 вакансий</div>

                    <div style="padding: 15px 0;">
                        <div><strong style="text-decoration: underline; font-size: 18px;">Супервайзер</strong></div>
                        <div style="font-size: 16px; color: #4b4b4b; margin-bottom: 15px;">«Балтика»</div>
                        <div style="padding-left: 25px; margin-bottom: 10px;">
                            <ul>
                                <li>Крупнейшая пивоваренная компания в России</li>
                                <li>Быстрый карьерный рост</li>
                                <li>Требуется трехлетний опыт по работе с персоналом, опыт управления</li>
                                <li>Уровень зарплаты устанавливается по итогу собеседования</li>
                            </ul>
                        </div>
                        <div>Присоединяйтесь к нашей энергичной й перспективной команде профессионалов.</div>
                    </div>


                    <div style="padding: 15px 0;">
                        <div><strong style="text-decoration: underline; font-size: 18px;">Медиа-менеджер</strong></div>
                        <div style="font-size: 16px; color: #4b4b4b; ">Три Сестры</div>
                        <div style="font-size: 14px; color: #4b4b4b; margin-bottom: 15px;">Управление персоналом > Менеджмент, высшее управление</div>
                        <div style="margin-bottom: 10px;">
                            Наша компания занимается тортами и десертами на заказ. Мы ищем менеджера социальных сетей, который будет вести социальные медиа и общаться с клиентами, собирать заказы. Гарантируем хорошую зарплату, оформление по ТК РФ. Опыт работы не требуется. На полную занятость готовы принять прямо сейчас (5/2 в уютном офисе).
                        </div>
                    </div>


                    <div style="padding: 15px 0;">
                        <div><strong style="text-decoration: underline; font-size: 18px;">Телефонные консультанты на временную работу</strong></div>
                        <div style="font-size: 16px; color: #4b4b4b; ">Банк-Бриксон</div>
                        <div style="font-size: 14px; color: #4b4b4b; margin-bottom: 15px;">Работа с медиа > Работа с клиентами</div>
                        <div style="margin-bottom: 10px;">
                            Ищете работу на неполный рабочий день или удаленную работу? Вы сможете работать на полную или частичную занятость, занимаясь продажами по телефону. Быстрое обучение. Опыт работы не требуется – необходимы только навыки общения по телефону.
                        </div>
                    </div>


                    <div style="padding: 15px 0;">
                        <div><strong style="text-decoration: underline; font-size: 18px;">Инженер-конструктор </strong></div>
                        <div style="font-size: 16px; color: #4b4b4b;">АвтоВаз</div>
                        <div style="font-size: 14px; color: #4b4b4b; margin-bottom: 15px;">Администраторы и секретари > Продавцы-консультанты</div>
                        <div style="padding-left: 25px; margin-bottom: 10px;">
                            <ul>
                                <li>Высшее техническое, инженерное образование</li>
                                <li>Опыт работы по специальности не менее трех лет</li>
                                <li>Полный соцпакет, отличная команда профессионалов</li>
                                <li>Офис в центре города</li>
                            </ul>
                        </div>
                        <div>Разработка технической документации: ТУ, инструкции по эксплуатации, паспорта на изделия. Подготовка конструкторской документации и технических требований для заводов изготовителей.</div>
                    </div>


                    <div style="padding: 15px 0;">
                        <div><strong style="text-decoration: underline; font-size: 18px;">Оператор станка</strong></div>
                        <div style="font-size: 16px; color: #4b4b4b;">ГазМетПром</div>
                        <div style="font-size: 14px; color: #4b4b4b; margin-bottom: 15px;">Строительство > Управление проектами</div>
                        <div style="margin-bottom: 10px;">
                            Разработка и внедрение технологического процесса в производство по изготовлению пресс-форм для изготовления изделий из ЭВА. Работа в ночную смену. Чтение чертежей. 2D, 3D моделирование, работа с алюминием.
                        </div>
                    </div>

                    <div style="padding: 15px 0;">
                        <div><strong style="text-decoration: underline; font-size: 18px;">Сельское хозяйство - Сельхозработник</strong></div>
                        <div style="font-size: 16px; color: #4b4b4b;">VetsuInc</div>
                        <div style="font-size: 14px; color: #4b4b4b; margin-bottom: 15px;">Производство > Рабочие и Операторы станков</div>
                        <div style="margin-bottom: 10px;">
                            Нам нужен человек, который имеет огромный опыт проектировании ландшафтного дизайна от 2 соток и до бесконечности. Вы должны четко и ясно понимать, что хочет заказчик. Вы должны уметь работать в программах по проектированию, визуализации и 3D
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    export default {}
</script>
<style scoped></style>
